import React from "react";
import CostRow from "./exp-cost-row";
import { calculateCostAccommodation, exchangeRate } from "./cost-helper";

const AccommodationRow = ({guideData, expData}) => {
    // Check if this is a REBEL villa (flat fee) or traditional accommodation (per attendee)
    const isVilla = expData.villaRentalFee !== undefined && expData.villaRentalFee.value !== undefined;
    // calculateCostAccommodation now returns per-attendee cost for both villa and traditional
    const perAttendeeCost = calculateCostAccommodation(guideData, expData);
    const totalAccommodationCost = perAttendeeCost * guideData.attendees.value;

    return (
        <React.Fragment>
            <CostRow title="Accommodation"
                    icon='bed'
                    single
                    currency={guideData.currency.value.slice(3)}
                    costPer={(expData, Number(totalAccommodationCost/guideData.tripLength.value))}
                    perLabel="per night"
                    num={guideData.tripLength.value}
                    type="nights"
                    subtotal={perAttendeeCost}
                    attendees={guideData.attendees.value}
                    //message={"Let's pop a message here."}
                    accommodation={expData}
                    exchangeRate={exchangeRate}
                    villaSubtotal={isVilla ? totalAccommodationCost : undefined}
            />
        </React.Fragment>
    )
}

export default AccommodationRow;